import { RegionModel } from 'services/EpdClient';

export const getDisplayRegionName = (regionId: string | null, regions: RegionModel[]): string | null => {
  if (!regionId) return null;

  const region = regions.find((region) => region.id === regionId);

  return region && !region.isMainRegion ? region.name ?? null : null;
};
